import React from 'react';

export default function Select({ label, className = '', children, ...rest }) {
  return (
    <div>
      {label && <label className="form-label">{label}</label>}
      <select className={`form-input bg-white ${className}`} {...rest}>
        {children}
      </select>
    </div>
  );
}
